export default __webpack_public_path__ + "static/media/icVisibleOn.d3e35595.svg";